import { render } from "./SliceList.vue?vue&type=template&id=09f2f236&scoped=true&ts=true"
import script from "./SliceList.vue?vue&type=script&lang=ts"
export * from "./SliceList.vue?vue&type=script&lang=ts"

import "./SliceList.vue?vue&type=style&index=0&id=09f2f236&lang=scss&scoped=true"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09f2f236"]])

export default __exports__